import icon from 'vue-svgicon';

icon.register({
    'regular/design-tool-magic-wand': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M22.151 2.85l-1.259 3.439 2.121 2.122a.735.735 0 0 1-.541 1.273l-3.653-.029-1.319 3.363a.785.785 0 0 1-1.485-.1L14.932 9.07 11.08 7.991a.786.786 0 0 1-.1-1.486l3.363-1.323-.029-3.653a.734.734 0 0 1 1.274-.543l2.122 2.121 3.441-1.257a.8.8 0 0 1 1 1zM14.932 9.07L.75 23.25" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
